import { useState, useRef, useEffect } from 'react';

export default function HelpButton() {
  const [isOpen, setIsOpen] = useState(false);
  const buttonRef = useRef(null);

  const helpContent = (
    <div className="help-modal p-4" style={{ maxWidth: '280px' }}>
      <h3 className="font-bold text-lg mb-3 text-gray-800">How to use the map</h3>
      <ul className="list-disc pl-5 space-y-2 text-sm text-gray-700">
        <li>Scroll to zoom in/out</li>
        <li>Click and drag to move around the map</li>
        <li>Red markers indicate AEDs from the local database</li>
        <li>Green markers represent AEDs from OpenStreetMap</li>
        <li>Click on a marker to see more information</li>
        <li>The location button (recenter) centers the map on your position</li>
      </ul>
    </div>
  );

  // Close the menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (buttonRef.current && !buttonRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const buttonStyle = {
    width: '36px',
    height: '36px',
    backgroundColor: isOpen ? '#f0f0f0' : 'white',
    border: 'none',
    cursor: 'pointer',
    padding: 0,
    margin: 0,
    outline: 'none',
    transition: 'all 0.2s ease',
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#3182ce',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  };

  return (
    <div className="leaflet-bottom leaflet-left" style={{ marginBottom: '10px', marginLeft: '10px' }}>
      <div 
        className="leaflet-control" 
        style={{ 
          borderRadius: '8px', 
          overflow: 'visible',
          zIndex: 1000
        }}
        ref={buttonRef}
      >
        <button 
          onClick={() => setIsOpen(!isOpen)}
          style={{
            ...buttonStyle,
            boxShadow: '0 1px 5px rgba(0,0,0,0.2)'
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.backgroundColor = '#f0f0f0';
          }}
          onMouseOut={(e) => {
            if (!isOpen) {
              e.currentTarget.style.backgroundColor = 'white';
            }
          }}
          aria-label="Help"
          title="Help"
        >
          ?
        </button>
        
        {isOpen && (
          <div 
            style={{
              position: 'absolute',
              left: 0,
              bottom: '100%',
              marginBottom: '5px',
              backgroundColor: 'white',
              borderRadius: '8px',
              width: '280px',
              border: '1px solid #e2e8f0',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
              zIndex: 1000
            }}
          >
            {helpContent}
          </div>
        )}
      </div>
    </div>
  );
}
